"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/core/browserFetch.ts
var browserFetch = typeof window !== "undefined" && typeof fetch !== "undefined" ? async (...args) => await fetch(...args) : null;
var browserFetch_default = browserFetch;


exports.default = browserFetch_default;

module.exports = exports.default;
